import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()({
    gridContainer: {
        marginBottom: "32px",
    },
});
